export default {
  PUBLISHED: 'published',
  CREATED: 'created',
  ARCHIVED: 'archived',
};
